import { useQuery } from "react-query";
import { getAffiliateAccountStatus } from "../api/user/getAffiliateAccountStatus";

export const useQueryGetAffiliateAccountStatus = () =>
  useQuery(["affiliate-account"], getAffiliateAccountStatus);
